import React from 'react';
import SideNavBar from './SideNavBar';
import { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';

const EquipmentInventory = () => {
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('darkMode');
    return saved === 'true'; // Convert string to boolean
  });
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef();

  const [equipmentData, setEquipmentData] = useState([
    {
      name: 'Camera',
      category: 'Media',
      condition: 'Fixed',
      location: 'Media store',
      purchaseDate: '03 Dec, 2025',
      purchasePrice: '₦240,640.00',
    },
    {
      name: 'Drum',
      category: 'Musical',
      condition: 'Good',
      location: 'Store room',
      purchaseDate: '01 Apr, 2025',
      purchasePrice: '₦563,350.00',
    },
    {
      name: 'Laptop',
      category: 'Media',
      condition: 'Excellent',
      location: 'Media store',
      purchaseDate: '10 Apr, 2025',
      purchasePrice: '₦270,000.00',
    },
    {
      name: 'Laptop',
      category: 'Media',
      condition: 'Excellent',
      location: 'Store room',
      purchaseDate: '09 Apr, 2025',
      purchasePrice: '₦300,300.00',
    },
    {
      name: 'Tripod Stand',
      category: 'Media',
      condition: 'Good',
      location: 'Media store',
      purchaseDate: '03 Feb, 2000',
      purchasePrice: '₦43,600.00',
    },
  ]);

  const handleDelete = indexToDelete => {
    const updatedData = equipmentData.filter((_, index) => index !== indexToDelete);
    setEquipmentData(updatedData);
  };

  // Close sidebar when clicking outside (mobile)
  useEffect(() => {
    if (!sidebarOpen) return;
    function handleClick(e) {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setSidebarOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [sidebarOpen]);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
    localStorage.setItem('darkMode', darkMode);
  }, [darkMode]);

  return (
    <div className={darkMode ? 'dark bg-gray-900 min-h-screen' : 'bg-white min-h-screen'}>
      {/* Dark mode toggle */}
      <button
        className={`fixed top-4 right-4 z-50 border-2 border-green-700 rounded-full p-2 shadow-lg transition hover:bg-green-700 hover:text-white
          ${darkMode ? 'bg-gray-800 text-yellow-400' : 'bg-white text-green-800'}`}
        onClick={() => setDarkMode(prev => !prev)}
        aria-label="Toggle dark mode"
      >
        {darkMode ? (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 3v1m0 16v1m8.66-13.66l-.71.71M4.05 19.95l-.71.71M21 12h-1M4 12H3m16.66 4.95l-.71-.71M4.05 4.05l-.71-.71M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        ) : (
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z"
            />
          </svg>
        )}
      </button>

      {/* Hamburger for mobile */}
      <button
        className="md:hidden fixed top-4 left-4 z-50 p-2 rounded-md bg-white text-black shadow-lg transition-colors duration-300 hover:bg-green-700 hover:text-white"
        onClick={() => setSidebarOpen(true)}
        aria-label="Open sidebar"
      >
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          strokeWidth={2}
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <div className="flex">
        {/* Sidebar - only sidebar is scrollable */}
        {/* Desktop sidebar */}
        <div
          className={`w-60 h-screen overflow-y-auto bg-gradient-to-r ${
            darkMode ? 'from-gray-900 to-gray-800' : 'from-green-800 to-yellow-200'
          } p-3 font-bold custom-scrollbar hidden md:block`}
        >
          <SideNavBar darkMode={darkMode} />
        </div>
        {/* Mobile sidebar overlay */}
        {sidebarOpen && <div className="fixed inset-0 z-40  bg-black bg-opacity-40 md:hidden" />}
        <div
          ref={sidebarRef}
          className={`fixed top-0 left-0 z-50 w-64 h-full bg-gradient-to-r ${
            darkMode ? 'from-gray-900 to-gray-800' : 'from-green-800 to-yellow-200'
          } p-3 font-bold custom-scrollbar transform transition-transform duration-300 md:hidden
            ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
          style={{ maxWidth: '16rem', overflowY: 'auto' }} // <-- Make mobile sidebar scrollable
        >
          <div className="flex justify-between items-center mb-4">
            <span className="font-bold text-lg text-white">Menu</span>
            <button
              className="p-2 rounded-md bg-gray-200 dark:bg-gray-100"
              onClick={() => setSidebarOpen(false)}
              aria-label="Close sidebar"
            >
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                strokeWidth={2}
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <SideNavBar darkMode={darkMode} />
        </div>
        <div className="w-full overflow-hidden">
          {/* Header and Action Buttons */}
          <div className="flex flex-col md:flex-row md:justify-between w-full gap-4 px-4 md:px-8">
            <div className="mt-6 md:mt-8">
              <h1
                className={`text-2xl font-bold text-center md:text-left ${
                  darkMode ? 'text-white' : 'text-gray-900'
                }`}
              >
                Equipment Inventory
              </h1>
              <p
                className={`text-sm mt-2 text-center md:text-left ${
                  darkMode ? 'text-gray-300' : 'text-gray-700'
                }`}
              >
                Manage and track all church equipment and assets
              </p>
            </div>

            <div className="flex flex-col md:flex-row gap-3 md:items-center">
              <NavLink to="/equipments">
                <div
                  className={`text-center p-2 rounded-md w-full md:w-44 ${
                    darkMode
                      ? 'bg-gray-700 font-semibold text-white'
                      : 'bg-slate-400 text-white font-semibold'
                  }`}
                >
                  &lt; Back to Equipment
                </div>
              </NavLink>
              <NavLink to="/addequipment">
                <div
                  className={`text-center p-2 rounded-md w-full md:w-44 ${
                    darkMode
                      ? 'bg-gray-700 font-semibold text-white'
                      : 'bg-green-900 text-white font-semibold'
                  }`}
                >
                  Add Equipment
                </div>
              </NavLink>
            </div>
          </div>

          {/* Table Section */}
          <div className="p-4 md:p-6 w-full mt-8">
            <div className="bg-white shadow rounded-lg overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    {[
                      'Name',
                      'Category',
                      'Condition',
                      'Location',
                      'Purchase Date',
                      'Purchase Price',
                      'Actions',
                    ].map(col => (
                      <th
                        key={col}
                        className="px-4 py-2 text-left text-xs font-medium text-gray-700 uppercase whitespace-nowrap"
                      >
                        {col}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-100">
                  {equipmentData.map((item, idx) => (
                    <tr key={idx} className="hover:bg-gray-50">
                      <td className="px-4 py-2 text-sm text-gray-800">{item.name}</td>
                      <td className="px-4 py-2 text-sm text-gray-800">{item.category}</td>
                      <td className="px-4 py-2 text-sm">
                        <span
                          className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium
      ${
        item.condition === 'Excellent'
          ? 'bg-green-100 text-green-800'
          : item.condition === 'Need Attention'
          ? 'bg-red-100 text-red-800'
          : item.condition === 'Recent Maintenance'
          ? 'bg-blue-100 text-blue-800'
          : item.condition === 'Fixed'
          ? 'bg-purple-100 text-purple-800'
          : 'bg-yellow-100 text-yellow-800' // fallback (e.g. Good/Fair)
      }`}
                        >
                          {item.condition}
                        </span>
                      </td>

                      <td className="px-4 py-2 text-sm text-gray-800">{item.location}</td>
                      <td className="px-4 py-2 text-sm text-gray-800">{item.purchaseDate}</td>
                      <td className="px-4 py-2 text-sm text-gray-800">{item.purchasePrice}</td>
                      <td className="px-4 py-2 text-sm flex items-center gap-2">
                        <NavLink
                          className="px-2 py-1 text-blue-600 hover:text-blue-800"
                          title="Edit"
                        >
                          <h1>✏️</h1>
                        </NavLink>
                        <NavLink
                          onClick={() => handleDelete(idx)} // or item.id if using ID
                          className="px-2 py-1 text-red-600 hover:text-red-800"
                          title="Delete"
                        >
                          <span>🗑️</span>
                        </NavLink>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Print Button */}
            <div className="w-full mt-4 flex justify-center md:justify-start">
              <button className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
                Print Inventory
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquipmentInventory;
